import {skillById,type ClassId,type Shortcut} from './professions';
import {classSkillIcon} from './classSkillAssets';

export function skillActionPresentation(binding:Shortcut,profession:ClassId,level:number,mana:number,readyAt:number,now:number){
 const skill=binding?.kind==='skill'?skillById(binding.id):undefined;
 const locked=!!skill&&(skill.classId!==profession||skill.level>level),seconds=Math.max(0,(readyAt-now)/1000);
 const state=!binding?'empty':locked?'locked':seconds>0?'cooldown':skill&&mana<skill.cost?'unaffordable':'ready';
 const reason=locked?(skill!.classId!==profession?'ต่างสายอาชีพ':`🔒 Lv.${skill!.level}`):seconds>0?`รอ ${seconds.toFixed(1)} วินาที`:state==='unaffordable'?'อาคมไม่พอ':'พร้อม';
 return {state,locked,seconds,cost:skill?.cost,overlay:locked?reason:seconds>0?seconds.toFixed(1):state==='unaffordable'?'SP!':'',description:skill?`${skill.name} · ใช้อาคม ${skill.cost} · ${reason}`:reason};
}

export function wardPresentation(wardUntil:number,now:number){
 const remaining=Number.isFinite(wardUntil)?Math.max(0,(wardUntil-now)/1000):0;
 return {active:remaining>0,seconds:remaining,text:remaining>0?`คุ้มกาย · ลดเสียหาย 12 · ${remaining.toFixed(1)} วิ`:''};
}

export function updateWardUi(wardUntil:number,now:number,doc:Document=document):void{
 const node=doc.getElementById('hud-ward-status');if(!node)return;const state=wardPresentation(wardUntil,now);node.hidden=!state.active;
 const copy=node.querySelector('span');if(copy&&copy.textContent!==state.text){
  copy.textContent=state.text;
  if(state.active){
   const anchors=[...doc.querySelectorAll<HTMLElement>('.hud-player,.party-toggle,.comms-toggle')].map(el=>el.getBoundingClientRect()).filter(rect=>rect.width>0&&rect.height>0);
   if(anchors.length)node.style.top=`${Math.ceil(Math.max(...anchors.map(rect=>rect.bottom))+6)}px`;
  }
 }
 const icon=node.querySelector<HTMLImageElement>('img'),src=classSkillIcon('sword-parry');if(icon&&icon.getAttribute('src')!==src)icon.src=src!;
}
